import { getUrlQuerysection } from "../../../../../../helpers";
import { useUrlSearch } from "../../../../../../hooks/useUrlSearch";
import { useGetPOCategories } from "../../../../../../hooks/api/queries";
import { useState } from "react";

export const useAllPOCategories = () => {
  const queries = getUrlQuerysection();
  const { search, gotoPage, filterBySearch } = useUrlSearch();
  const [isCreatePO, setIsCreatePO] = useState(false);
  const { isLoading: isLoadingPOCat, data } = useGetPOCategories({ queries });

  return {
    isLoadingPOCat,
    pOCategories: data?.data || [],
    metaDetails: data?.meta,
    search,
    isCreatePO,
    setIsCreatePO,
    filterBySearch,
    gotoPage,
  };
};
